var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109.4 124.5",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#95BF47",
    d: "M74.7 14.8c-.2-.1-.4-.2-.5-.1l-10.7 3.3c-2.7-4.4-7.5-7.4-12.7-7.4-.7 0-1.4.1-2.1.2C46.3 5 42.1.6 36.8.6c-.7 0-1.3.1-1.9.2C33.2.3 31.4 0 29.5 0 20.3 0 13.9 8.2 13.9 17.5c0 1.9.3 3.8.8 5.6l-10 3.1c-1.3.4-1.4 2.2-.1 2.7l16.1 5.9v78.2c0 2.2 1.8 4 4 4h54.8c2.2 0 4-1.8 4-4V29.4l16.3-5c1.3-.4 1.4-2.2.1-2.7l-25.2-6.9zM36.8 4.7c3.1 0 5.7 2.3 6.6 5.4l-7.7 2.4c-1.1-.3-2.1-.5-3.3-.5-1.9 0-3.6.5-5 1.4 1.8-5.3 5.4-8.7 9.4-8.7zm-7.3-.6c.9 0 1.7.1 2.5.3-2.6 4.3-4.5 9.9-5.1 16.3l-8.6 2.6c-.4-1.8-.7-3.8-.7-5.8 0-7.3 4.9-13.4 11.9-13.4zm21.3 10c3.7 0 7 2.2 8.7 5.5l-13.9 4.3c.7-5.7 2.6-9.8 5.2-9.8zM24.8 111.4V34.5l25 9.2v67.7H24.8zm30-2.3V44.2l20.4-6.3v71.2H54.8zm23.8-76.3l-20.4 6.3-27.1-9.9 43.1-13.3 4.4 16.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E8E3E",
    d: "M73.4 17.9l-10.7 3.3c-2.7-4.4-7.5-7.4-12.7-7.4-.7 0-1.4.1-2.1.2L74.7 14.8c-.2-.1-.5 0-.7.2l-.6 2.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M57.6 62.4c-3.1 0-5.4-1.3-6.9-3.8l5.2-3.1c.9 1.4 2.2 2.2 3.8 2.2 1.9 0 3-.9 3-2.2 0-3.7-11.7-2.3-11.7-10.8 0-4.7 3.7-8.3 9.4-8.3 3.6 0 6.2 1.3 7.8 3.6l-4.9 3.2c-.9-1.2-2-1.9-3.4-1.9-1.5 0-2.5.8-2.5 1.9 0 3.4 11.7 2.1 11.7 10.6 0 5-4.1 8.6-11.5 8.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopify);
export default __webpack_public_path__ + "static/media/shopify.0b6e80fe14849b9b4eb9ab417a31aa80.svg";
export { ForwardRef as ReactComponent };